import * as React from 'react';
import { useState } from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { Grow, Slide } from '@mui/material';

export const GrowTransition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement;
	},
	ref: React.Ref<unknown>
) {
	return <Grow ref={ref} {...props} />;
});

export const SlideUpTransition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement;
	},
	ref: React.Ref<unknown>
) {
	const [direction, setDirection] = useState<'up' | 'down'>('up');

	return (
		<Slide
			direction={direction}
			onEntered={() => setDirection('up')}
			onExited={() => setDirection('down')}
			ref={ref}
			{...props}
		/>
	);
});
